import { ThemeService } from './../../services/theme.service';
import { Location, LocationStrategy } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { LoaderService } from 'src/app/shared/loader/loader.service';
import { AlunosModel } from '../alunos/alunos.model';
import { BloquearProfessor } from '../models/bloquear-professor';
import { MarcarQuestao } from '../models/marcar-questao';
import { ProfessorModel } from '../models/professor.model';
import { QuestionarioModel } from '../models/questionario.model';
import { AlunoService } from '../services/aluno.service';
import { ProfessorService } from '../services/professor.service';
import { sortBy } from 'lodash';
import { NgxHotjarService } from 'ngx-hotjar';
import { GoogleAnalyticsService } from 'ngx-google-analytics';
import { environment } from 'src/environments/environment';
import { QuestionarioService } from '../services/questionario.service';
import { ToastrService } from 'ngx-toastr';
import { BreakpointObserver, BreakpointState } from '@angular/cdk/layout';

interface RequestError {
  code: string;
  message: string;
}

@Component({
  selector: 'app-questionario',
  templateUrl: './questionario.component.html',
  styleUrls: ['./questionario.component.scss'],
})
export class QuestionarioComponent implements OnInit {

  private doc = document.documentElement;
  public innerWidth: any;
  listaMostrar: boolean = true;
  poaFinalizada: boolean = true;

  showPageInstrucoes: boolean = false;

  constructor(
    private activatedRoute: ActivatedRoute,
    private alunoService: AlunoService,
    private questionarioService: QuestionarioService,
    private locationStrategy: LocationStrategy,
    private location: Location,
    public professorService: ProfessorService,
    private loaderService: LoaderService,
    private themeService: ThemeService,
    private hotjar: NgxHotjarService,
    private analytics: GoogleAnalyticsService,
    private breakpointObserver: BreakpointObserver,
    private toastr: ToastrService
  ) {
    history.pushState(null, null, window.location.href);
    this.locationStrategy.onPopState(() => {
      history.pushState(null, null, window.location.href);
      return false;
    });
    this.isMobile = this.isMobileDevice();
    this.exibirListaMobile();

  }

  error: RequestError;

  erroFormulario = false;

  professores: ProfessorModel[];

  poaPessoaHash: '';

  selectedProfessor: ProfessorModel;
  selectedProfessorAnterior: ProfessorModel;
  indexAnterior: number = 0;

  aluno: AlunosModel;

  questoes: QuestionarioModel;

  comentarioOpen = false;

  showQuestion = false;

  loading = false;

  reavaliado: boolean = false;

  professoresAvaliados: number = 0;

  avaliandoProfessor: boolean = false;

  isMobile: boolean = false;
  mobileViewLista: boolean = true;
  mobileViewForm: boolean = true;

  marcarQuestao(questao: MarcarQuestao) {
    this.professores[questao.index].questoes = questao.respondidas;
  }

  exibirListaMobile() {
    if (this.isMobile) {

      this.mobileViewLista = true;
      this.mobileViewForm = false;

      var html = document.querySelector('html')

      if(html.scrollTop > 10) {
        setTimeout(() => {
          let professorSelecionado = this.professores?.findIndex(el => el.selected)
    
          if(professorSelecionado != null && professorSelecionado >= 0) {
            this.scrollProfessor(professorSelecionado, false);
          }
        },10)
      }
    }
  }

  exibirFormMobile() {
    if (this.isMobile) {
      this.mobileViewLista = false;
      this.mobileViewForm = true;
    }
  }

  exibirFinalizacaoMobile() {
    //if (this.isMobile) {
      this.mobileViewLista = false;
      this.mobileViewForm = false;
    //}
  }

  resetMobile() {
      this.mobileViewLista = true;
      this.mobileViewForm = true;
  }

  back() {
    this.comentarioOpen = false;
    this.location.back();
  }

  comments() {
    this.comentarioOpen = true;

    this.professores.map((p) => (p.selected = false));

    var professoresAvaliados = this.professores.filter((p) => this.professorAvaliado(p));
    if (professoresAvaliados.length == this.professores.length) {
      this.hotjar.trigger("questionario_poa__questionario__pesquisa_concluida")
      console.log("Finalizado")
    }
  }

  public quantidadeAvaliada(professores: ProfessorModel[]) {
    let avaliados = 0;
    professores.forEach(element => {
      if (this.professorAvaliado(element))
        avaliados = avaliados + 1
    });

    return avaliados;
  }

  professorAvaliado(professor: ProfessorModel): boolean {
    if (professor.naoSabeAvaliarProfessor || professor.naoPossuiAulaComProfessor)
      return true

    var minimoQuesitosNecessarios = Math.ceil(professor.quesitos.length / 2)
    var quesitosRespondidos = professor.questoes

    return quesitosRespondidos >= minimoQuesitosNecessarios
  }


  pularProfessor(professor: ProfessorModel) {
    const selected = this.professores.find((p) => p.id === professor.id);

    const index = this.professores.indexOf(selected);
    this.selectProfessor(index + 1);

    if (index > 0)
      this.listaProfessoresDisplay(false);
  }

  reavaliacaoRequest(event: boolean) {
    this.reavaliado = event
  }

  exibirListaProfessoresRequest(event: boolean) {
    this.listaMostrar = event;
    this.avaliandoProfessor = false;
    this.exibirListaMobile();
  }

  selectProfessor(index: number, ini: boolean = false) {

    if (this.poaFinalizada)
      this.comentarioOpen = true;

    if (index >= this.professores.length) {
      return;
    }

    if(this.professores[index].professorFinalizado){
      this.reavaliado = true
    }else
    {
      this.reavaliado = false
    }

    this.showQuestion = false;
    this.loaderService.show();

    this.professores.map((prof) => (prof.selected = false));

    this.professores[index].selected = true;

    this.selectedProfessor = this.professores[index];
    this.selectedProfessorAnterior = this.selectedProfessor;
    this.indexAnterior = index;

    this.questoes = this.selectedProfessor as any;

    for (let i = 0; i < this.questoes.quesitos.length; i++) {
      this.questoes.quesitos[i] = Object.assign(this.questoes.quesitos[i], {
        selected: false,
        avaliado: this.questoes.quesitos[i].hashOpcaoSelecionada
          ? true
          : false,
      });

      for (let k = 0; k < this.questoes.quesitos[i].opcoes.length; k++) {
        this.questoes.quesitos[i].opcoes[k] = Object.assign(
          this.questoes.quesitos[i].opcoes[k],
          {
            selected: false,
          }
        );

        const opcoes = this.questoes.quesitos[i].opcoes.find(
          (al) => al.id === this.questoes.quesitos[i].hashOpcaoSelecionada
        );

        if (opcoes)
          opcoes.selected = true;
      }

    }

    if (index > 0)
      this.listaProfessoresDisplay(false);
    else if (index == 0 && !ini) {
      this.listaProfessoresDisplay(false);
    }

    if (!ini) {
      if (this.isMobile) {
        this.exibirFormMobile();
      }
    }

    this.showQuestion = true;
    this.loaderService.hide();

    if(!this.isMobile)
      this.scrollProfessor(index);
  }

  getIndexProfessorSelecionado(): number {
    return this.professores.indexOf(this.selectedProfessor);
  }

  bloquearProfessorNaoPossuiAula(bloqueado: BloquearProfessor): void {
    this.professores[bloqueado.index].naoPossuiAulaComProfessor = bloqueado.checked;
    if (bloqueado.checked) {
      this.professores[bloqueado.index].questoes = 0;
      this.selectProfessor(bloqueado.index + 1);

      return;
    }
    this.selectProfessor(bloqueado.index);
  }

  bloquearProfessorNaoSabeAvaliar(bloqueado: BloquearProfessor): void {
    this.professores[bloqueado.index].naoSabeAvaliarProfessor = bloqueado.checked;
    if (bloqueado.checked) {
      this.professores[bloqueado.index].questoes = 0;
      this.selectProfessor(bloqueado.index + 1);

      return;
    }
    this.selectProfessor(bloqueado.index);
  }


  ngOnInit(): void {
    let breakpoints = ['(max-width: 768px)', '(min-width: 992px)'];
    this.breakpointObserver
      .observe(breakpoints)
      .subscribe((state: BreakpointState) => {
        this.onResize()
      });

    this.innerWidth = window.innerWidth;
    this.isMobile = this.isMobileDevice();

    this.loading = true;
    this.activatedRoute.paramMap.subscribe((params) => {
      this.alunoService.validarTokenAluno(params.get('token'))
        .subscribe((aluno) => {
          this.aluno = aluno;

          if (this.aluno.pertenceEscex == true)
            this.themeService.setElevaTheme();
          else
            this.themeService.setGlobalTheme();

          sessionStorage.setItem('@poaquestionario:token', this.aluno.token);

          this.alunoService.getFormularios(aluno.tokenAcesso)
            .subscribe(prof => {
              this.professores = prof.map(f =>
                Object.assign(f, {
                  nomeExibicao: (f.ehDisciplinaEletiva ? f.disciplina : f.nome),
                  selected: false,
                  ehDisciplinaEletiva: f.ehDisciplinaEletiva,
                  professorFinalizado: f.quesitos.some(x => x.hashOpcaoSelecionada !== null),
                  disabled: false,
                  questoes: f.quesitos
                    .filter(x => x.hashOpcaoSelecionada !== null)
                    .map(a => a.hashOpcaoSelecionada).length,
                })
              );

              this.poaPessoaHash = prof[0]?.poaPessoaHash;

              this.professores = sortBy(this.professores, ['tipo', 'ehDisciplinaEletiva', 'nomeExibicao'], 'asc');

              this.exibirListaMobile();

              this.selectProfessor(0, true);

              this.professoresAvaliados = this.quantidadeAvaliada(this.professores);
              this.loaderService.hide();
              this.loading = false;

              this.showPageInstrucoes = this.mostrarPaginaInstrucao();

              this.comentarioOpen = false;
              this.poaFinalizada = false;

              if (prof[0]?.finalizado == true) {
                this.comentarioOpen = true;
                this.poaFinalizada = true;
                this.exibirFinalizacaoMobile();
                this.listaProfessoresDisplay(false);
              }

            }, (err => {
              this.loaderService.hide();
              this.loading = false;
              this.error = err.errors?.find(f => f.message)?.message;
            }));

          this.configureTracks(aluno)
        },
          (err) => {
            this.loaderService.hide();
            this.loading = false;
            this.error = err.errors?.find(f => f.message)?.message;
          }
        );
    },
      (err) => {
        this.loaderService.hide();
        this.loading = false;
        this.error = (err.errors ?? [{}])[0].description;
      });
  }
  configureTracks(aluno) {
    this.hotjar.hj('identify', aluno.usuarioHash, {
      'Rede': aluno.rede,
      'Domínio': document.location.hostname,
      'Perfil': aluno.perfilAcesso,
      'Escola': aluno.escola,
      'Usuário': aluno.usuarioHash,
      'Segmento': aluno.segmento,
      'Série': aluno.serie,
      'Matrícula': aluno.matricula,
    });

    this.analytics.gtag('config', 'GA_MEASUREMENT_ID', {
      'custom_map': {
        'dimension1': aluno.rede,
        'dimension2': document.location.hostname,
        'dimension3': aluno.perfilAcesso,
        'dimension4': aluno.escola,
        'dimension6': aluno.usuarioHash,
        'dimension7': aluno.segmento,
        'dimension8': aluno.serie,
      }
    });
  }

  customEventInstructions(event: boolean): void {
    this.showPageInstrucoes = event;
  }

  private mostrarPaginaInstrucao(): boolean {
    if (this.professoresAvaliados > 0 || (localStorage.getItem("@termoAceite") === this.aluno.tokenAcesso)) {
      return false;
    }
  
    return true;
  }

  scrollProfessor(index: number, animado: boolean = true) {
    var elements = document.querySelectorAll('.card-content');
    const target = elements[index] as HTMLElement;
    if (target) {
      var parent = target.parentNode as any
      if(this.isMobile) {
        parent = document.querySelector('html');
      }

      parent.scrollTo({
        top: target.offsetTop - parent.offsetTop,
        behavior: animado ? 'smooth' : 'instant'
      })
    }
  }

  retornarPortal() {
    window.location.replace(environment.paths.portal);
  }

  onResize() {
    const elemento = document.getElementById('div-lista-professores');
    this.innerWidth = window.innerWidth;
    this.isMobile = this.isMobileDevice();

    this.exibirListaMobile();

    if (this.innerWidth > 991.98) {
      this.listaProfessoresDisplay(true);
      this.resetMobile();

    }
  }

  listaProfessoresDisplay(visualizar: boolean = true) {
    if (this.innerWidth <= 991.98)
      this.listaMostrar = visualizar;
  }

  reciverFeedback(hashs) {
    if (this.professores.indexOf(this.selectedProfessor) === hashs['index'])
      this.professores[hashs['index']]['comentario'] = hashs['comentarioProfessor'];
  }

  formularioFeedback(status) {
    if (status) {
      this.selectedProfessor.professorFinalizado = true;
      const professoresFinalizados = this.professores.filter(professor => professor.professorFinalizado === true);

      this.professoresAvaliados = professoresFinalizados.length;

      this.exibirListaMobile();
    }

  }

  finalizarPOA() {

    this.erroFormulario = false;

    if (this.professores.length > 0 && this.professoresAvaliados === this.professores.length) {
      this.loaderService.show();
      this.loading = true;
      this.questionarioService.finalizarPOA(this.poaPessoaHash)
        .subscribe(
          () => {
          this.loaderService.hide();
          this.loading = false;
          this.comentarioOpen = true;
          this.exibirFinalizacaoMobile();
          this.listaProfessoresDisplay(false);

          this.hotjar.trigger("questionario_poa__questionario__pesquisa_finalizada")

        }, (err => {
          this.loaderService.hide();
          this.loading = false;
          this.error = err.errors?.find(f => f.message)?.message;
        }));
    }else{
      this.toastr.error('Para enviar, é preciso avaliar todos os professores',
                    null,
                    {
                        closeButton: true,
                        disableTimeOut: false
                    });
    }
  }

  isMobileDevice(): boolean {
      const width = window.innerWidth;

      if (width <= 991) {
        return true; // É uma tela extra pequena
      } else {
        return false; // Não é
      }
  }

}
